import { IOrganization } from "@tickeat/types";

export type OrganizationFormValues = Pick<IOrganization, 'email'>;

export const transformOrganizationFormValuesToPayload = (values: Partial<IOrganization>): Partial<IOrganization> => {
  return {
    email: values.email,
  }
}

export const transformToUpdatableFormOrganization = (organization?: Partial<IOrganization>): OrganizationFormValues => {
  return {
    email: organization?.email ?? '',
  }
}
